import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const TransporterMappedInfoComponent = ({agents,shippingModes,shippingProviders,shippingTypes, selectedTransporters, onInnerFormChange }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
                  label="shippingTypes" 
                  labelField="ShippingTypeName"
                  list={shippingTypes}
                  onValueChange={(newValue: any ) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '')
                  onInnerFormChange(
                    valueData,
                    'MappedShippingTypes.ShippingTypeIds',
                     selectedTransporters?.MappedShippingTypes
                  );
                } }
                type="multiselect"
                 valueField="Id"
                value={selectedTransporters?.MappedShippingTypes?.ShippingTypeIds} />
        <InputContainer
                  label="Agents" 
                  labelField="Name"
                  list={agents}
                  onValueChange={(newValue: any ) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '');
                  onInnerFormChange(
                    valueData,
                    'MappedAgents.AgentIds',
                  selectedTransporters?.MappedAgents
                  );
                } }
                type="multiselect"
                 valueField="Id"
                value={selectedTransporters?.MappedAgents?.AgentIds} />
          <InputContainer
                  label="ShippingProviders" 
                  labelField="Name"
                  list={shippingProviders}
                  onValueChange={(newValue: any ) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '');
                  onInnerFormChange(
                    valueData,
                    'MappedShippingProviders.ShippingProviderIds',
                  selectedTransporters?.MappedShippingProviders
                  );
                } }
                type="multiselect"
                 valueField="Id"
                value={selectedTransporters?.MappedShippingProviders?.ShippingProviderIds} />
      <InputContainer
                  label="ShippingModes" 
                  labelField="Name"
                  list={shippingModes}
                  onValueChange={(newValue: any ) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '');
                  onInnerFormChange(
                    valueData,
                    'MappedShippingModes.ShippingModeIds',
                  selectedTransporters?.MappedShippingModes
                  );
                } }
                type="multiselect"
                 valueField="Id"
                value={selectedTransporters?.MappedShippingModes?.ShippingModeIds} />
   
    </div>
 }
 expandedPanel="mappedInfo"
 headerTitle="Mappedt Info"
/>
</>
)
export default TransporterMappedInfoComponent;
